import { Client } from "./ClientInterface";
import { ResourceCentre } from "./ResourceCentreInterface";

export const ClientLinkRequestStatus = {
  PENDING: "pending",
  APPROVED: "approved",
  REJECTED: "rejected"
} as const;

export type ClientLinkRequestStatusType =
  (typeof ClientLinkRequestStatus)[keyof typeof ClientLinkRequestStatus];

export interface ClientLinkRequest {
  id: number;
  requestingResourceCentreId: number;
  destinationResourceCentreId: number;
  clientId: number;
  status: ClientLinkRequestStatusType;
  remark?: string;
  created_at: string;
  updated_at: string;

  // related fields
  client: Client;
  requestingResourceCentre: ResourceCentre;
  destinationResourceCentre: ResourceCentre;
}
